import React, { FC, useContext } from 'react';

import { H3, Link, Separator, Toggle, Tooltip } from '@smartshell/ui-kit';

import { SettingsLock, TimeOutInput } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LINKS } from 'links';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './PostPayment.module.scss';

export const PostPayment: FC = () => {
  const { t, lang } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);
  const isAvailable = useIsFeatureAvailable('post_payments');

  return (
    <div className={s.block}>
      <Toggle
        label={t('setting.post_payment')}
        description={t('settings.billing.postPayment.description')}
        value={settings.postPaymentEnabled}
        onChange={(value: boolean) =>
          setSetting({
            alias: ESettingsAliases.POST_PAYMENT_ENABLED,
            value: value ? '1' : '0',
          })
        }
        variant="secondary"
        emptyBg
        disabled={!isAvailable}
        rightContent={
          !isAvailable ? (
            <SettingsLock />
          ) : (
            <Tooltip
              contentClassName={s.tooltip_content}
              content={
                <div className={s.tooltip}>
                  <H3>{t('setting.post_payment')}</H3>
                  <span className={s.text}>
                    {t('settings.billing.postPayment.tooltip')}
                  </span>
                  <Link title={t('more')} link={LINKS.post_payment[lang]} />
                </div>
              }
            />
          )
        }
      />
      <Separator />
      <TimeOutInput
        label={t('setting.post_payment.duration')}
        setting={settings.postPaymentMaxDuration}
        updateSetting={setSetting}
        settingAlias={ESettingsAliases.POST_PAYMENT_MAX_DURATION}
        inMinutes
        minMinutes={5}
        maxMinutes={1440}
        disabled={settings.postPaymentEnabled}
      />
    </div>
  );
};
